import React from "react";
import s from "./SendMessage.module.scss";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import { ContactsIcon } from "../../../../../global components/Icons/ContactsIcon";
import clsx from "clsx";
import BreadCrumb from "../../../../../global components/BreadCrumbs/BreadCrumbs";
import Separator from "../../../../../global components/Icons/Separator";
function SendMessage() {
  const {msgId}=useParams()
  const location = useLocation();
  const pathName = location.pathname;
  const items = [
    {
      title: (
        <Link to="/dashboard/users/">
          <ContactsIcon className={s.icon} /> User
        </Link>
      ),
    },
  ];

  if (pathName.includes("users")) {
    items.push({
      title: (
        <Link
          onClick={(e) => e.preventDefault()}
          className={clsx(pathName.includes("users") && s.active)}
          to="/dashboard/api-management/requests/users"
        >
          Send message
        </Link>
      ), // Added title text
    });
  } else if (pathName.includes("send-message")) {
    items.push({
      title: (
        <Link
          onClick={(e) => e.preventDefault()}
          className={clsx(pathName.includes("send-message") && s.active)}
          to="/dashboard/users/send-message"
        >
          Send message
        </Link>
      ), // Added title text
    });
  }
  if (pathName.includes("details")) {
    items.push({
      title: (
        <Link
          onClick={(e) => e.preventDefault()}
          className={clsx(pathName.includes("details") && s.active)}
          to={`/dashboard/users/send-message/details/${msgId}`}
        >
          View details
        </Link>
      ), // Added title text
    });
  }
  return (
    <div className={s.wrapper}>
      <div className={s.breadCrumb}>
        <BreadCrumb
          items={items}
          separator={<Separator height={11} width={6.67} fill="#9CA3AF" />}
        />
      </div>
      <Outlet />
    </div>
  );
}

export default SendMessage;
